import { createFileRoute, redirect } from '@tanstack/react-router'

import { requireManage } from '@/auth/require-manage'

export const Route = createFileRoute('/_layout/announcements/$announcementId')({
  beforeLoad: ({ context }) => {
    requireManage(context.me, 'announcements', redirect({ to: '/announcements', replace: true }))
  },
})
